<template>
    <div class="spin-page">
        <div class="top-actions">
            <button class="action-btn" @click="showLog = !showLog">
                <i class="bi bi-three-dots-vertical"></i>
            </button>
            <!-- <button @click="enterFullscreen" class="action-btn">
                <i class="bi bi-arrows-fullscreen"></i>
            </button> -->
            <button class="action-btn" @click="toggleFullscreen">
                <i :class="isFullscreen ? 'bi bi-fullscreen-exit' : 'bi bi-arrows-fullscreen'"></i>
            </button>

            <!-- <div class="test-btn-group">
                <button @click="testBigPrize(1)" class="action-btn">Test BIG 1</button>
                <button @click="testBigPrize(2)" class="action-btn">Test BIG 2</button>
                <button @click="testBigPrize(3)" class="action-btn">Test BIG 3</button>
                <button @click="testBigPrize(4)" class="action-btn">Test BIG 4</button>
                <button @click="testBigPrize(5)" class="action-btn">Test BIG 5</button>
                <button @click="testBigPrize(6)" class="action-btn">Test BIG 6</button>
            </div> -->

        </div>


        <transition name="slide-fade">
            <div v-if="showLog" class="log-panel">
                <div class="log-header">
                    <h5 class="mb-0">รายการของรางวัล</h5>
                    <button class="log-close" @click="showLog = false">×</button>
                </div>

                <div class="prize-list">
                    <div v-for="prize in prizes" :key="prize.id" class="prize-item">
                        <div>
                            <div class="fw-bold">{{ prize.name }}</div>
                            <div class="text-muted small">จำนวนทั้งหมด {{ prize.total || '-' }} รางวัล</div>
                        </div>
                        <div class="remain-badge" :class="{ empty: prize.remaining === 0 }">
                            เหลือ {{ prize.remaining }}
                        </div>
                    </div>
                </div>

            </div>
        </transition>

        <div class="spin-stage">
            <div class="wheel-wrap">
                <div class="pointer">
                    <img src="@/assets/images/pin-2.png" class="pointer-img" />
                </div>

                <div class="wheel" :style="{
                    transform: `rotate(${rotation}deg)`,
                    transition: spinning ? 'transform 5s cubic-bezier(0.17, 0.67, 0.12, 0.99)' : 'none'
                }">
                    <div v-for="(prize, index) in prizes" :key="prize.id" class="segment"
                        :class="{ disabled: prize.remaining === 0 }" :style="getSegmentStyle(index, prize.color)">
                        <div class="segment-content">
                            <div class="segment-inner">
                                <img :src="getWheelImage(prize)" class="segment-image" :style="getImageStyle(index)" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="wheel-center-badge" :class="{ disabled: spinning || totalRemaining === 0 }" @click="spinWheel">
                    <template v-if="spinning">
                        <span class="spin-text spinning-text">Spinning...</span>
                    </template>

                    <template v-else-if="totalRemaining === 0">
                        <span class="spin-text disabled-text">Out of prizes</span>
                    </template>

                    <template v-else>
                        <img src="../assets/images/Logo-Pet-Pawrents.png" class="center-logo" />
                    </template>
                </div>
            </div>

        </div>

        <div v-if="result" class="gift-modal-overlay" @click.self="closeGift">
            <div class="gift-modal">

                <!-- ปุ่มปิด -->
                <!-- <button class="gift-close" @click="closeGift">×</button> -->

                <!-- ยังไม่เปิด -->
                <div v-if="!opened" class="gift-box" @click="openGift">
                    <img src="@/assets/images/OriginalCharacters_TransparentBG_06.png" class="gift-img" />
                </div>

                <!-- เปิดแล้ว -->
                <!-- <div v-else class="gift-result">

                    <div class="gift-image-wrap">
                        <img :src="getPrizeImage(result)" class="gift-image" />
                        <div class="gift-name">{{ result.name }}</div>
                    </div>
                </div> -->

                <div v-else class="gift-result">

                    <div class="gift-image-wrap" :class="{ 'big-prize': isBigPrize(result) }">
                        <img :src="getPrizeImage(result)" class="gift-image" />

                        <div class="gift-name" :class="{ 'big-text': isBigPrize(result) }">
                            {{ result.name }}
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>
  
<script>
export default {
    name: "SpinWheel",
    data() {
        return {
            rotation: 0,
            spinning: false,
            result: null,
            prizes: [],
            showLog: false,
            opened: false,
            isFullscreen: false
        };
    },
    computed: {
        segmentAngle() {
            return this.prizes.length ? 360 / this.prizes.length : 0;
        },
        totalRemaining() {
            return this.prizes.reduce((sum, item) => sum + item.remaining, 0);
        }
    },
    watch: {
        result(val) {
            if (val) {
                this.opened = false;

                // 🔥 preload รูป
                const img = new Image();
                img.src = this.getPrizeImage(val);

                setTimeout(() => {
                    this.openGift();
                }, 1500);
            }
        }
    },
    mounted() {
        document.addEventListener('fullscreenchange', () => {
            this.isFullscreen = !!document.fullscreenElement;
        });
    },
    async mounted() {
        const data = await this.$store.dispatch('getListPrizes');
        if (!data) return;

        this.prizes = data.prizes.map(p => ({
            id: p.id,
            name: p.name,
            shortName: p.short_name.replace(/\\n/g, '\n'),
            total: p.total,
            remaining: p.remaining,
            color: p.color,
            image: p.images,
            wheelImage: p.wheel_image
        }));
    },
    methods: {
        getSegmentStyle(index, color) {
            const angle = this.segmentAngle;

            return {
                transform: `
            rotate(${index * angle}deg)
            skewY(${-(90 - angle)}deg)
        `,
                background: color
            };
        },

        async spinWheel() {
            if (this.spinning || this.totalRemaining === 0) return;

            this.spinning = true;
            this.result = null;
            this.opened = false;

            const data = await this.$store.dispatch('getPrizes');

            if (!data || !data.success) {
                alert('ของรางวัลหมดแล้ว');
                this.spinning = false;
                return;
            }

            const targetIndex = this.prizes.findIndex(p => p.id === data.prize.id);

            const fullSpins = 6;
            const anglePerSegment = this.segmentAngle;

            const pointerOffset = 90;

            const targetAngle =
                360 - (targetIndex * anglePerSegment + anglePerSegment / 2) + pointerOffset;

            const finalRotation =
                this.rotation + fullSpins * 360 + targetAngle - (this.rotation % 360);

            this.rotation = finalRotation;

            setTimeout(() => {
                this.prizes[targetIndex].remaining = data.remaining;
                this.result = {
                    ...data.prize,
                    remaining: data.remaining,
                };
                this.spinning = false;
            }, 5000);
        },

        getTextRotateStyle(index) {
            const angle = this.segmentAngle;
            const rotate = index * angle + angle / 2;

            const fix = rotate > 180 ? 180 : 0;

            return {
                transform: `

        `
            };
        },
        openGift() {
            this.opened = true;
        },

        closeGift() {
            this.result = null;
            this.opened = false;
        },

        getPrizeImage(prize) {
            if (!prize.images) return '/default.png';

            if (Array.isArray(prize.images)) {
                return prize.images[0];
            }

            return prize.images;
        },
        getWheelImage(prize) {
            return prize.wheelImage || '/default-wheel.png';
        },
        getImageStyle(index) {
            const angle = this.segmentAngle;
            const skew = 90 - angle;

            return {
                transform: `
            translate(-50%, -50%)
            skewY(${skew}deg)
            rotate(${angle / 2}deg)
            translateY(60%)
            rotate(${-angle / 2}deg)
        `
            };
        },
        enterFullscreen() {
            const el = document.documentElement;

            if (el.requestFullscreen) {
                el.requestFullscreen();
            } else if (el.webkitRequestFullscreen) {
                el.webkitRequestFullscreen();
            }
        },
        toggleFullscreen() {
            const el = document.documentElement;

            if (!document.fullscreenElement) {
                // 👉 เข้า fullscreen
                if (el.requestFullscreen) {
                    el.requestFullscreen();
                } else if (el.webkitRequestFullscreen) {
                    el.webkitRequestFullscreen();
                }
            } else {
                // 👉 ออกจาก fullscreen
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                }
            }
        },
        isBigPrize(prize) {
            return [2, 4].includes(prize.id);
        },
        testBigPrize(id = 2) {
            const prize = this.prizes.find(p => p.id === id);
            console.log('TEST BIG', this.result);

            this.result = {
                ...prize,
                images: prize.image,
                remaining: prize.remaining
            };

            this.opened = true;
        }
    }
};
</script>

<style scoped>
.spin-page {
    position: relative;
    min-height: 100vh;
    overflow: hidden;
    background-position: center top;
    /* background: url('../assets/images/pawrents_Backdrop.jpg') center center / cover no-repeat; */
    background: url('../assets/images/pawrents_Backdrop.png') center bottom / cover no-repeat;

}



.spin-stage {
    min-height: 100vh;
    display: grid;
    grid-template-rows: 1fr auto;
    justify-items: center;
    align-items: center;
    padding: 24px 16px 28px;
}

.wheel-wrap {
    position: relative;

    width: min(870px, 95vw);
    height: min(870px, 95vw);

    max-width: 870px;
    max-height: 870px;

    min-width: 300px;
    min-height: 300px;
}

.pointer {
    position: absolute;
    right: -3vw;
    /* ปรับเข้า-ออกตามรูป */
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
}

.pointer-img {
    width: clamp(80px, 8vw, 160px);
    /* 🔥 เพิ่มจาก 60 → 80 / max 160 */
    height: auto;

    object-fit: contain;

    filter: drop-shadow(0 12px 24px rgba(0, 0, 0, 0.45)) drop-shadow(0 0 10px rgba(255, 255, 255, 0.6));
}

.wheel {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
    border: 14px solid #fff;
    box-shadow:
        0 22px 60px rgba(244, 110, 11, 0.22),
        inset 0 0 22px rgba(255, 255, 255, 0.65);
    background: radial-gradient(circle, #fff 0%, #ffe9dc 100%);
}

.segment {
    position: absolute;
    width: 50%;
    height: 50%;
    top: 0;
    left: 50%;
    transform-origin: 0% 100%;
}

.segment.disabled {
    opacity: 0.3;
    filter: grayscale(100%);
}

.segment-content {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* ตัวนี้เอาไว้ “ดัน text ออกไปกลาง slice” */
/* .segment-inner {
    transform: translateY(-35%);
} */
.segment-inner {
    position: relative;
    width: 100%;
    height: 100%;
}

.segment-image {
    position: absolute;
    top: 50%;
    left: 50%;
    width: clamp(90px, 20vw, 220px);
    height: auto;
    object-fit: contain;
    transform-origin: center center;
    pointer-events: none;
    display: block;
}

/* text */
.segment-text {
    width: clamp(90px, 12vw, 130px);
    text-align: center;

    font-size: clamp(13px, 1.4vw, 18px);
    font-weight: 700;
    color: #222;
    line-height: 1.2;

    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);

    /* 🔥 สำคัญ: ทำให้ text ตั้งตรง */
    transform: rotate(calc(-1 * var(--rotate-angle)));

    white-space: pre-line;
}

.segment-text strong {
    display: block;
    white-space: pre-line;
}

.wheel-center-badge {
    position: absolute;
    inset: 50% auto auto 50%;
    transform: translate(-50%, -50%);

    width: 190px;
    /* 🔥 เพิ่มขนาด */
    height: 190px;

    border-radius: 50%;

    background: #ffffff;
    /* 🔥 ขาวล้วน */
    color: #000;
    /* เผื่อมี text */

    display: flex;
    align-items: center;
    justify-content: center;

    box-shadow:
        0 12px 30px rgba(0, 0, 0, 0.15),
        inset 0 0 10px rgba(0, 0, 0, 0.05);

    z-index: 4;
    cursor: pointer;
    transition: all 0.25s ease;
}

.wheel-center-badge:hover {
    transform: translate(-50%, -50%) scale(1.05);
}

.wheel-center-badge:active {
    transform: translate(-50%, -50%) scale(0.95);
}

.center-logo {
    width: 120%;
    height: auto;
}

.bottom-ui {
    width: min(92vw, 760px);
    display: grid;
    gap: 18px;
    justify-items: center;
    margin-top: 10px;
}

.spin-btn {
    border: none;
    min-width: 220px;
    padding: 16px 34px;
    border-radius: 999px;
    background: linear-gradient(135deg, #f46e0b, #ff8c42);
    color: #fff;
    font-weight: 800;
    font-size: 18px;
    box-shadow: 0 12px 28px rgba(244, 110, 11, 0.35);
    transition: all 0.25s ease;
    cursor: pointer;
}

.spin-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 16px 36px rgba(244, 110, 11, 0.45);
}

.spin-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.result-box {
    width: min(92vw, 560px);
    background: #fff;
    border-radius: 22px;
    padding: 20px 22px;
    text-align: center;
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);
}

.result-title {
    font-size: 22px;
    font-weight: 800;
    color: #f46e0b;
}

.result-sub {
    margin-top: 6px;
    color: #666;
}

/* log toggle */
.top-actions {
    position: fixed;
    top: 18px;
    right: 18px;
    z-index: 20;

    display: flex;
    align-items: center;
    gap: 8px;
}

.action-btn {
    border: none;
    border-radius: 999px;

    padding: 10px 12px;

    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(6px);

    color: #000;
    font-size: 18px;

    display: flex;
    align-items: center;
    justify-content: center;

    transition: 0.2s;
}

.action-btn:hover {
    transform: scale(1.1);
}

.log-panel {
    position: fixed;
    top: 16px;
    right: 16px;
    width: min(92vw, 420px);
    max-height: calc(100vh - 32px);
    overflow: auto;
    background: rgba(255, 255, 255, 0.98);
    border-radius: 20px;
    box-shadow: 0 18px 48px rgba(0, 0, 0, 0.16);
    z-index: 30;
    padding: 14px;
    backdrop-filter: blur(10px);
}

.log-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
}

.log-close {
    border: none;
    background: transparent;
    font-size: 26px;
    line-height: 1;
}

.prize-list {
    display: grid;
    gap: 10px;
}

.prize-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 14px;
    background: #fff;
    padding: 14px 16px;
    border-radius: 14px;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06);
}

.remain-badge {
    white-space: nowrap;
    font-weight: 700;
    background: #dddddd;
    color: #000000;
    border-radius: 999px;
    padding: 8px 12px;
}

.remain-badge.empty {
    background: #fff1f0;
    color: #cf1322;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.22s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
    opacity: 0;
    transform: translateY(-8px);
}

@media (max-width: 768px) {
    .wheel-wrap {
        width: min(92vw, 92vw);
        height: min(92vw, 92vw);
    }

    .wheel-center-badge {
        width: 86px;
        height: 86px;
        font-size: 16px;
    }

    .pointer {
        border-left-width: 22px;
        border-right-width: 22px;
        border-top-width: 46px;
    }

    .segment-text {
        width: 82px;
        font-size: 12px;
    }

    .spin-btn {
        width: 100%;
        max-width: 360px;
        font-size: 17px;
    }
}

.result-pointer {
    position: absolute;
    top: 40px;
    /* ใกล้ pointer */
    left: 50%;
    transform: translateX(-50%);

    background: #f46e0b;
    color: #fff;

    padding: 10px 18px;
    border-radius: 12px;

    font-weight: 700;

    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);

    animation: pop 0.3s ease;
}

@keyframes dropIn {
    from {
        transform: translate(-50%, -30px);
        opacity: 0;
    }

    to {
        transform: translate(-50%, 0);
        opacity: 1;
    }
}

.gift-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    backdrop-filter: blur(6px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
}

.gift-modal {
    background: transparent;
    border-radius: 24px;
    padding: 30px 24px;
    /* width: min(90vw, 360px); */
    text-align: center;
    position: relative;

    animation: pop 0.35s ease;
}

.gift-close {
    position: absolute;
    top: 5px;
    right: 5px;
    border: none;
    background: transparent;
    font-size: 24px;
    color: #000;
}

.gift-box {
    font-size: 200px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.gift-box:hover {
    transform: scale(1.1) rotate(-6deg);
}

.gift-text {
    font-size: 18px;
    color: #ffffff;
    margin-top: 3px;
}

.gift-image {
    width: min(80vw, 660px);
    border-radius: 20px;
    /* 👈 responsive */
    height: auto;
    /* 👈 สำคัญ */
    max-height: 70vh;
    /* กันล้นจอ */
    object-fit: contain;
    margin-bottom: 12px;
}

.gift-name {
    font-weight: 800;
    font-size: 18px;
    color: #ffffff;
}

.gift-img {
    max-height: 60vh;
    object-fit: contain;
}


/* hover effect */
.gift-box:hover .gift-img {
    transform: scale(1.1) rotate(-5deg);
}

.gift-result {
    text-align: center;
    animation: fadeUp 0.4s ease;
}

/* กรอบรูป */
.gift-image-wrap {
    background: #ffffff2e;
    border-radius: 20px;
    padding: 10px;

    box-shadow:
        0 20px 50px rgba(0, 0, 0, 0.15),
        inset 0 0 10px rgba(0, 0, 0, 0.05);

    display: inline-block;
}

/* รูป */
.gift-image {
    width: min(90vw, 600px);
    height: auto;

    max-height: 75vh;
    object-fit: contain;
}

/* badge */
.gift-badge {
    margin-top: 16px;
    font-weight: 800;
    font-size: 14px;
    color: #fff;

    background: linear-gradient(135deg, #f46e0b, #ff8c42);
    display: inline-block;
    padding: 6px 14px;
    border-radius: 999px;

    box-shadow: 0 6px 14px rgba(244, 110, 11, 0.4);
}


/* sub text */
.gift-sub {
    margin-top: 6px;
    font-size: 14px;
    color: #666;
}

/* animation */
@keyframes fadeUp {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes pop {
    from {
        transform: scale(0.8);
        opacity: 0;
    }

    to {
        transform: scale(1);
        opacity: 1;
    }
}

.gift-box {
    animation: float 0.6s ease;
}

@keyframes float {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.08) rotate(-3deg);
    }

    100% {
        transform: scale(1);
    }
}

.spin-text {
    font-weight: 800;
    text-align: center;
    line-height: 1.2;
    padding: 6px 10px;
    border-radius: 12px;
    transition: all 0.25s ease;
}

/* 🔄 spinning */
.spinning-text {
    font-size: clamp(14px, 1.6vw, 18px);
    color: #f46e0b;

    animation: pulse 1s infinite ease-in-out;
}

/* ❌ no prize */
.disabled-text {
    font-size: clamp(13px, 1.5vw, 16px);
    color: #999;

    background: rgba(0, 0, 0, 0.05);
}

/* animation */
@keyframes pulse {
    0% {
        transform: scale(1);
        opacity: 1;
    }

    50% {
        transform: scale(1.08);
        opacity: 0.7;
    }

    100% {
        transform: scale(1);
        opacity: 1;
    }
}

/* 🔥 BIG PRIZE เอฟเฟค */
.big-prize {
    position: relative;

    animation: bigPop 0.5s ease;

    box-shadow:
        0 0 0 4px #fff,
        0 0 30px rgba(255, 215, 0, 0.9),
        0 0 60px rgba(255, 140, 0, 0.7);

    background: radial-gradient(circle, #fff 0%, #fff5e6 100%);
}

.big-prize::after {
    content: '';
    position: absolute;
    inset: -6px;
    border-radius: 22px;

    background: radial-gradient(circle,
            rgba(232, 125, 47, 0.35) 0%,
            rgba(232, 125, 47, 0.15) 40%,
            transparent 70%);

    filter: blur(8px);
    z-index: -1;
}



/* 🔥 text ใหญ่ */
.big-text {
    font-size: 26px;
    font-weight: 900;

    background: linear-gradient(135deg, #ff9a4d, #e87d2f);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

@keyframes softPulse {
    0% {
        opacity: 0.6;
        transform: scale(0.98);
    }

    50% {
        opacity: 1;
        transform: scale(1.02);
    }

    100% {
        opacity: 0.6;
        transform: scale(0.98);
    }
}

.big-prize {
    animation:
        bigPop 0.5s ease,
        softPulse 1.2s ease-in-out 2;
}

.test-btn-group {
    position: fixed;
    top: 80px;
    right: 20px;
    z-index: 50;

    display: flex;
    flex-direction: column;
    gap: 6px;
}
</style>